import { useState } from "react";
import { useAppSelector } from "../../store/hooks";
import CitizenListItem from "./CitizenListItem";
import { filterBySearchTerm, sortByName } from "../../utils/arrayUtils";
import Checkbox from "../UI/input/Checkbox";
import constraintStyles from "../../styles/constraint.module.css";
import labels from "../../utils/labels";
import InputTextField from "../UI/input/InputTextField";
import { formatCitizenAddress } from "../../service/citizenAddress";

const CitizensConstraintTab = () => {
  const citizens = useAppSelector((state) => state.constraintSlice.clients);
  const [showWithConstraintsOnly, setShowWithConstraintsOnly] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  const sortedCitizens = sortByName(
    filterBySearchTerm(
      showWithConstraintsOnly
        ? citizens.filter((c) => c.constraints && c.constraints.length > 0)
        : citizens,
      (c) => [c.description, formatCitizenAddress(c)],
      searchTerm,
    ),
    (c) => c.description,
  );

  return (
    <>
      {citizens.length > 0 && (
        <div className={constraintStyles.header}>
          <InputTextField
            id="citizen-constraint-search"
            label={labels.searchCitizenConstraint}
            placeholder={labels.typeName}
            direction="COLUMN"
            fieldWidth="300px"
            onInputChange={setSearchTerm}
            value={searchTerm}
          />
          <Checkbox
            checked={showWithConstraintsOnly}
            onChange={setShowWithConstraintsOnly}
            label={labels.showCitizensWithConstraintsOnly}
          />
        </div>
      )}
      <div>
        {sortedCitizens.map((citizen) => (
          <CitizenListItem key={citizen.idServiceClient} citizen={citizen} />
        ))}
      </div>
    </>
  );
};

export default CitizensConstraintTab;
